import { Hero } from '@/components/Hero'
import { statamicGraphqlEndpoint } from '@/globals/globals'
import { Box, Container, Heading, SimpleGrid } from '@chakra-ui/react'
import request, { gql } from 'graphql-request'
import { GetStaticProps } from 'next'
import NextLink from 'next/link'

export const getStaticProps: GetStaticProps = async () => {
  const data = await request(
    statamicGraphqlEndpoint,
    gql`
      query MyQuery {
        entries(collection: "downloads") {
          data {
            ... on Entry_Downloads_Downloads {
              id
              title
              slug
              thumbnail {
                ... on Asset_Main {
                  id
                  url
                  width
                  height
                }
              }
            }
          }
        }
      }
    `
  )

  return {
    props: {
      data: data.entries.data,
    },
    revalidate: 60,
  }
}

export const Page = ({ data }: any) => {
  return (
    <>
      <Hero
        heading='Downloads'
        subheading='Download Game Mods, Custom Gauges, and More'
      />
      <Container py={20} maxWidth='6xl'>
        <SimpleGrid columns={{ base: 1, xl: 2 }} gap={{ base: 6, xl: 12 }}>
          {data.map((item: any) => (
            <Box key={item.id} mb={8}>
              <NextLink
                href={`/downloads/${item.slug}`}
                passHref
                legacyBehavior>
                <a>
                  <Card item={item} />
                </a>
              </NextLink>
            </Box>
          ))}
        </SimpleGrid>
      </Container>
    </>
  )
}

export const Card = ({ item, children }: any) => {
  return (
    <Box bg='white' height='100%'>
      <Box position='relative'>
        <img
          src={item.thumbnail.url}
          alt={item.title}
          style={{
            objectFit: 'contain',
            objectPosition: 'center',
            width: '100%',
            height: '100%',
          }}
        />
      </Box>
      <Box p={6}>
        <Heading as='h3' size='md' mb={2}>
          {item.title}
        </Heading>
        {children}
      </Box>
    </Box>
  )
}

export default Page
